import { apiSlice } from "@/services/api-slice";
import { APIResponse } from "@/types/custom-http";
import { RoleWorkspace, CreateRoleWorkspace, UpdateRoleWorkspace } from "./roles-workspaces.interface";

export const rolesWorkspacesApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getRolesWorkspaces: builder.query<APIResponse<RoleWorkspace[]>, void>({
      query: () => ({ url: "auth/workspaces/roles" }),
      providesTags: ["RolesWorkspaces"],
    }),

    getRoleWorkspaceById: builder.query<APIResponse<RoleWorkspace>, number>({
      query: (id) => ({ url: `auth/workspaces/roles/${id}` }),
      providesTags: (_result, _error, id) => [{ type: "RolesWorkspaces", id }],
    }),

    createRoleWorkspace: builder.mutation<APIResponse<RoleWorkspace>, CreateRoleWorkspace>({
      query: (data) => ({
        url: "auth/workspaces/roles",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["RolesWorkspaces"],
    }),

    updateRoleWorkspace: builder.mutation<APIResponse<RoleWorkspace>, { id: number; changes: UpdateRoleWorkspace }>({
      query: ({ id, changes }) => ({
        url: `auth/workspaces/roles/${id}`,
        method: "PATCH",
        body: changes,
      }),
      invalidatesTags: (_result, _error, { id }) => [{ type: "RolesWorkspaces", id }, "RolesWorkspaces"],
    }),
  }),
});

export const {
  useGetRolesWorkspacesQuery,
  useLazyGetRolesWorkspacesQuery,
  useGetRoleWorkspaceByIdQuery,
  useLazyGetRoleWorkspaceByIdQuery,
  useCreateRoleWorkspaceMutation,
  useUpdateRoleWorkspaceMutation,
} = rolesWorkspacesApi;
